// The product's AI gradient, so every surface the agent owns reads as the same thing.
const aiGradient = ({ theme }) =>
  `linear-gradient(91deg, ${theme.colors.purple} 11.1%, ${theme.colors.violet} 42.2%, ${theme.colors.primary} 76.3%)`;

export default aiGradient;
